// ─────────────────────────────────────────────
//  DONNÉES DU SITE — à éditer pour personnaliser
// ─────────────────────────────────────────────

import proj1_1 from "../images/projet1_1.png";
import proj1_2 from "../images/projet1_2.png";
import proj1_3 from "../images/projet1_3.png";
import proj1_4 from "../images/projet1_4.png";
import proj1_5 from "../images/projet1_5.png";
import proj2_1 from "../images/projet2_1.jpg";
import proj2_2 from "../images/projet2_2.jpg";
import proj2_3 from "../images/projet2_3.jpg";
import proj2_4 from "../images/projet2_4.jpg";
import proj2_5 from "../images/projet2_5.jpg";
import proj2_6 from "../images/projet2_6.jpg";
import proj2_7 from "../images/projet2_7.jpg";
import proj3_1 from "../images/projet3_1.jpg";
import proj3_2 from "../images/projet3_2.png";
import proj3_3 from "../images/projet3_3.png";
import proj3_4 from "../images/projet3_4.png";

export const siteInfo = {
  name: "Brice Terrier",
  role: "Paysagiste",
  email: "briceterrier.1808@gmail.com",
  phone: "06 28 60 20 64",
  location: "1230 route d'Hurigny, 71960 La Roche-Vineuse",
  footer: "Conçu avec soin · Cultivé avec passion",
};

export const navLinks = [
  { label: "À propos", href: "#a-propos" },
  { label: "Savoir-faire", href: "#savoir-faire" },
  { label: "Projets", href: "#projets" },
  { label: "Contact", href: "#contact" },
];

export const hero = {
  tag: "Brice Terrier",
  title: "Réaliser des aménagements d'avenir.",
  scrollLabel: "Découvrir",
};

export const about = {
  sectionLabel: "À propos",
  heading: "Une approche sensible du paysage",
  headingEmphasis: "sensible",
  paragraphs: [
    "Depuis l'enfance, mon lien à la nature s'est forgé au rythme des nombreux après-midis passés dans le jardin de mes grands-parents. Avec le temps, cet attachement s'est naturellement traduit dans mon orientation scolaire et m'a conduit à me tourner vers le domaine du paysage. Aujourd'hui, je souhaite m'y investir pleinement et contribuer à la création d'aménagements porteurs de sens, capables d'inscrire les espaces dans une dynamique vivante et durable.",
    "Après trois années de formation en alternance, combinant expérience de terrain et travail en infographie, je souhaite poursuivre mon parcours à travers une nouvelle formation qui me permettrait de consolider et élargir mes compétences dans le domaine du paysage.",
  ],
  cards: [
    {
      num: "01",
      title: "Mon parcours",
      text: "Mon parcours scolaire dans le paysage a débuté par l'obtention d'un BTSA Aménagements Paysagers, au cours duquel j'ai acquis les bases du métier, tant dans les aspects techniques de réalisation d'aménagements et de gestion de travaux que dans la connaissance du monde végétal et de la biodiversité. Par la suite, j'ai poursuivi mon parcours par une licence professionnelle en infographie paysagère, qui m'a permis de me familiariser avec les outils et les méthodes propres au domaine de la conception.",
    },
    {
      num: "02",
      title: "Mes intérêts",
      text: "Dans cette même recherche de contact avec la nature, je pratique régulièrement la randonnée, qui me permet à la fois de me dépasser physiquement mais aussi de nourrir ma créativité. Le sport occupe également une place importante dans ma vie. Je pratique notamment le rugby depuis l'âge de six ans, une discipline qui m'a beaucoup apporté sur le plan personnel, notamment à travers l'esprit d'équipe et le dépassement de soi. Par ailleurs, la cuisine est une passion qui m'accompagne depuis de nombreuses années et à travers laquelle j'apprécie particulièrement faire plaisir à mes proches. Enfin, je porte un intérêt à l'art, et plus particulièrement à la photographie. Cette sensibilité artistique me semble essentielle dans le domaine du paysage afin de concevoir des espaces à la fois réfléchis, fonctionnels et esthétiques.",
    },
    {
      num: "03",
      title: "Ma vision",
      text: "Le paysage est à mon sens un équilibre subtil entre fonctionnalité, esthétisme et respect de l'environnement. Il se doit de créer une émotion chez ses usagers tout en s'inscrivant pleinement dans son contexte. Je pense qu'un espace bien pensé doit inviter à la découverte et éveiller la curiosité tout en restant accueillant. La lumière, les couleurs et les textures contribuent à cette expérience et permettent de créer des ambiances variées et vivantes. Le paysage est pour moi un moyen de réaliser des lieux où l'humain et la nature se rencontrent harmonieusement. Aujourd'hui, il constitue un élément essentiel de notre société, mobilisant des moyens importants tant chez les particuliers que dans le secteur public. C'est pourquoi je souhaite contribuer à cette innovation et participer à bâtir les espaces de demain.",
    },
  ],
};

export const savoirFaire = {
  sectionLabel: "Savoir-faire",
  blocks: [
    {
      title: "BTSA Aménagements Paysagers",
      titleEmphasis: "en alternance",
      paragraphs: [
        "Apprentissage des techniques de réalisation d'éléments paysagers tels que des terrasses, murets, clôtures, allées, bassins naturels...",
        "Connaissance des végétaux ainsi que leurs techniques de plantation et d'entretien associées.",
        "Connaissances dans le fonctionnement des écosystèmes naturels et urbains ainsi que dans les notions de biodiversité et de développement durable.",
        "Capacité à élaborer des projets paysagers avec la réalisation de plans et de dossiers techniques.",
        "Compétences dans l'organisation et le suivi d'un chantier.",
      ],
      tags: ["Réalisation paysagère", "Végétaux", "Biodiversité", "Plans techniques", "Conduite de chantier", "Développement durable"],
    },
    {
      title: "Licence Infographie Paysagère",
      titleEmphasis: "en alternance",
      paragraphs: [
        "Maîtrise des principes de conception graphique et de représentation paysagère.",
        "Capacité à concevoir des plans d'aménagement paysager en accord avec la demande du client et les contraintes du site.",
        "Utilisation de logiciels permettant des rendus 2D et 3D tels qu'AutoCAD, SketchUp, Twinmotion, Photoshop...",
        "Compétences en communication et mise en œuvre d'un projet paysager.",
      ],
      tags: ["Conception graphique", "AutoCAD", "SketchUp", "Twinmotion", "Photoshop", "Communication projet"],
    },
  ],
};

export const projects = [
  {
    id: 1,
    num: "01",
    title: "Projet tutoré de fin d'étude",
    location: "Dijon, Côte-d'Or",
    image: proj1_1,
    desc: "Au cours de mon année de licence, j'ai participé avec mes camarades à la réalisation d'un projet paysager de réaménagement de cour pour un collège à Dijon. Nous devions effectuer l'ensemble du projet dans les règles d'un marché public, de l'analyse du site jusqu'aux propositions d'aménagements.",
    details: "Au cours de multiples rendez-vous nous avons pu déterminer les demandes du commanditaire : la requalification des espaces, la création de zones d'ombrages, la création de nouvelles assises ainsi que l'apport de végétalisation et la désimperméabilisation des sols dans le but de créer un îlot de fraîcheur. Le tout en respectant les servitudes et contraintes du site ainsi que le budget.",
    link: "/projet1.pdf",
    subImages: [proj1_2, proj1_3, proj1_4, proj1_5],
  },
  {
    id: 2,
    num: "02",
    title: "Jardin de Château",
    location: "Blanot, Saône-et-Loire",
    image: proj2_1,
    desc: "J'ai eu l'occasion de réaliser ce projet sur le terrain durant une année en entreprise lors de mon BTS. Celui-ci avait pour but d'aménager un jardin complet autour d'une piscine naturelle où auparavant se trouvait un terrain vague.",
    details: "Nous avons implanté une piscine naturelle de 19 mètres de long aux formes asymétriques avec une terrasse en bois à son extrémité. Nous avons réalisé des murs de soutènement en poutres de chêne pour créer deux niveaux ainsi qu'un cabanon et des escaliers également en poutres de chêne. Sans oublier l'implantation de nombreux massifs, arbres, arrosages automatiques, bordures en acier corten, la pose de gazon en rouleau et la création d'une zone en gravier.",
    link: null,
    subImages: [proj2_2, proj2_3, proj2_4, proj2_5, proj2_6, proj2_7],
  },
  {
    id: 3,
    num: "03",
    title: "Jardin d'une maison de vacances",
    location: "Sainte-Radegonde, Saône-et-Loire",
    image: proj3_1,
    desc: "Pour ce projet d'aménagement de jardin, je me suis vu attribuer la tâche de créer une coupe technique de format 1/50 à destination des ouvriers pour leur apporter une meilleure compréhension des travaux à réaliser ainsi qu'un plan de récolement du réseau hydraulique d'un bassin naturel à destination des clients.",
    details: "",
    link: null,
    subImages: [proj3_2, proj3_3, proj3_4],
  },
];

export const contact = {
  sectionLabel: "Contact",
  heading: "Comment me contacter ?",
  headingEmphasis: "contacter",
  intro: "En espérant vous avoir convaincu du sérieux de ma candidature, je vous remercie d'avoir pris le temps de l'examiner. Je reste disponible pour toute question ou renseignement.",
  ctaLabel: "Envoyer un mail",
};
